import { createApp } from "vue";
import App from "./App.vue";
import axios from "axios";
import { OktaAuth } from "@okta/okta-auth-js";
import OktaVue from "@okta/okta-vue";
import router from "./router";
import store from "./store";
import sfConfig from '@/config';

const oktaAuth = new OktaAuth(sfConfig.oidc)

const app = createApp(App);
app.use(store).use(router).use(OktaVue, { oktaAuth });

app.config.globalProperties.lambdaUrl = sfConfig.lambdaUrl;
// app.config.globalProperties.apikey = apikey;
app.config.globalProperties.$http = axios;
app.config.globalProperties.automationConfigUrl = sfConfig.automationConfigUrl;

// Async initialization to fetch publication-wise issue limit from API
async function initializeApp() {
  try {
    // 1) IMPORTANT: if returning from Okta redirect, process tokens first
    if (oktaAuth.isLoginRedirect()) {
      await oktaAuth.handleLoginRedirect();
      // handleLoginRedirect may navigate; but token storage will be done
    }

    // 2) Get token from tokenManager (reliable, async)
    const tokenObj = await oktaAuth.tokenManager.get("accessToken");
    const accessToken = tokenObj?.accessToken;

    if (!accessToken) {
      // Not authenticated yet; either trigger login or mount app and let UI handle it
      console.warn("Access token not available yet. User may not be authenticated.");
    }

    const fetchSecretApi = sfConfig.fetchSecretApi;
    let secretName1 = 'cg_apikey';
    // Make GET request
    const resFetchApi1 = await axios.get(
      `${fetchSecretApi}?secretName=${encodeURIComponent(secretName1)}`,
      {
        headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
      }
    );
    if (resFetchApi1.status !== 200) {
      throw new Error(`HTTP error! Status: ${resFetchApi1.status} while fetching secret`);
    }
    const apikey = resFetchApi1.data.message;
    app.config.globalProperties.apikey = apikey;

    let secretName2 = 'automation_config_bearer';
    // Make GET request
    const resFetchApi2 = await axios.get(
      `${fetchSecretApi}?secretName=${encodeURIComponent(secretName2)}`,
      {
        headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
      }
    );
    if (resFetchApi2.status !== 200) {
      throw new Error(`HTTP error! Status: ${resFetchApi2.status} while fetching secret`);
    }
    const automationConfigToken = resFetchApi2.data.message;

    const postData = {
      view: 'view_storyfinder_issues_display'
    };

    const response = await axios.post(
      `${app.config.globalProperties.automationConfigUrl}`,
      postData,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${automationConfigToken}`
        }
      }
    );
    // console.log(response);

    app.config.globalProperties.pubWiseIssueLimit = response.data;
    console.log('view_storyfinder_issues_display loaded from Automation Config API');
    // console.log(app.config.globalProperties.pubWiseIssueLimit);
  } catch (error) {
    console.error('Failed to fetch view_storyfinder_issues_display from Automation Config API, using fallback:', error);
    // Fallback to config value if API fails
    app.config.globalProperties.pubWiseIssueLimit = sfConfig.publicationWiseIssueLimit;
  } finally {
    // Mount the app after data is loaded
    app.mount('#app');
  }
}

// Initialize and mount the app
initializeApp();
